<template>
  <div>
    <b-modal
      ref="list-product-batch-modal"
      hide-footer
      :titleHtml="modalTitle"
      size="lg"
      @close="closeModal"
      @hide="closeModal"
    >
      <div class="wizard-nav-bg">
        <b-col cols="12" class="py-8 custom-card-body">
          <b-row class="mb-5">
            <b-col md="3">
              <b-form-input
                v-model="queryParams.batchCode"
                placeholder="Tìm kiếm mã lô"
              />
            </b-col>
            <b-col class="d-flex align-items-center" md="3">
              <b-button-group size="sm">
                <b-button
                  style="width: 70px"
                  class="font-weight-bolder"
                  variant="primary"
                  @click="onFilter"
                  ><i class="fas fa-search text-white fa-lg"></i>Lọc
                </b-button>
                <b-button
                  variant="primary"
                  v-b-toggle.collapse-1
                  class="togge-filter"
                  ><i class="fas fa-angle-down"></i
                ></b-button>
              </b-button-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-pagination
                pills
                v-show="totalPages >= 2"
                v-model="queryParams.page"
                :total-rows="totalItems"
                :per-page="queryParams.limit"
                @change="handlePageChange"
                align="right"
                class="mt-3"
                style="border-radius: 5px"
              ></b-pagination>
            </b-col>
          </b-row>
          <v-form ref="form" lazy-validation>
            <b-table
              :items="listItem"
              :fields="fields"
              :tbody-tr-class="rowClass"
              bordered
              hover
              :busy="onLoading"
              show-empty
            >
              <template v-slot:table-busy>
                <vcl-table :speed="5" :animate="true" :columns="4"></vcl-table>
              </template>
              <template #empty>
                <div class="text-center text-muted py-4">
                  <i class="fas fa-box-open fa-lg d-block mb-2"></i>
                  Sản phẩm này chưa có mã lô tồn kho
                </div>
              </template>
              <template v-slot:cell(batchCode)="row">
                <span class="font-weight-bold" v-text="row.item.batchCode"></span>
              </template>
              <template v-slot:cell(importDate)="row">
                <div class="text-center">
                  <div>{{ formatBatchDate(row.item.importDate) }}</div>
                  <small class="text-muted">{{
                    batchAgeText(row.item.importDate)
                  }}</small>
                </div>
              </template>
              <template v-slot:cell(availableQuantity)="row">
                <div class="text-center">
                  <span
                    :class="
                      row.item.availableQuantity > 0
                        ? 'font-weight-bold'
                        : 'text-danger font-weight-bold'
                    "
                    >{{ row.item.availableQuantity }}</span
                  >
                </div>
              </template>
              <template v-slot:cell(actions)="row">
                <div class="d-flex justify-content-center">
                  <b-badge
                    v-if="row.item.id === currentSelectedId"
                    variant="success"
                    class="py-1 px-2"
                  >
                    <i class="fas fa-check mr-1"></i>Đang chọn
                  </b-badge>
                  <b-badge
                    v-else-if="excludedIds.includes(row.item.id)"
                    variant="secondary"
                    class="py-1 px-2"
                    v-b-tooltip
                    title="Lô này đã được chọn ở dòng khác của cùng sản phẩm"
                  >
                    Đã chọn ở dòng khác
                  </b-badge>
                  <b-button
                    v-else
                    size="sm"
                    variant="primary"
                    class="font-weight-bold py-1 px-3"
                    :disabled="row.item.availableQuantity <= 0"
                    @click="
                      applyProductBatchStockCode(
                        row.item.id,
                        row.item.batchCode,
                        row.index,
                      )
                    "
                    >Chọn
                  </b-button>
                </div>
              </template>
            </b-table>
            <b-button
              style="font-weight: 600; width: 70px"
              variant="secondary"
              size="sm"
              @click="hideModal"
              >Hủy
            </b-button>
          </v-form>
          <b-row>
            <b-col>
              <b-pagination
                pills
                v-show="totalPages >= 2"
                v-model="queryParams.page"
                :total-rows="totalItems"
                :per-page="queryParams.limit"
                @change="handlePageChange"
                align="right"
                class="mt-3"
                style="border-radius: 5px"
              ></b-pagination>
            </b-col>
          </b-row>
        </b-col>
      </div>
    </b-modal>
  </div>
</template>

<script>
import ApiService from '@/core/services/api.service';
import { VclTable } from 'vue-content-loading';
import { convertPrice, makeToastFaile } from '@/utils/common';
import { formatDate } from '@/utils/date';
import { ProductBatchQueryParams } from '@/view/pages/product-batch-stock/models/ProductBatchQueryParams';
import { paginationMixin } from '@/view/mixins';

const thBase = { fontWeight: 600, color: '#181c32', textAlign: 'center' };

export default {
  // bucket: 'warranty' => picker lọc + hiển thị tồn theo warrantyQuantity (chuyển kho bảo hành);
  //         mặc định (null/undefined) => inStockQuantity (bán/xuất/chuyển thường).
  props: ['billItemId', 'productName', 'storeId', 'parent', 'excludedBatchStockIds', 'bucket'],
  mixins: [paginationMixin],
  data() {
    return {
      modalTitle: '',
      searchText: '',
      listItem: [],
      // id lô ĐANG chọn của dòng SP (set khi mở modal) — để highlight + đánh dấu "Đang chọn".
      currentSelectedId: null,
      // Cột gọn theo bản chất "chọn lô để bán": Mã lô · Ngày nhập (tuổi lô, FIFO) · Tồn còn · Chọn.
      fields: [
        { key: 'batchCode', label: 'Mã lô', thStyle: { ...thBase } },
        { key: 'importDate', label: 'Ngày nhập', thStyle: { ...thBase, width: '22%' } },
        { key: 'availableQuantity', label: 'Tồn còn', thStyle: { ...thBase, width: '16%' } },
        { key: 'actions', label: '', thStyle: { ...thBase, width: '18%' } },
      ],
      listReson: [],
      onLoading: false,
      queryParams: {
        page: 1,
        limit: 10,
        batchCode: null,
      },
      productId: null,
    };
  },
  components: {
    VclTable,
  },
  watch: {},
  computed: {
    // id các lô đã chọn ở DÒNG KHÁC cùng SP → disable để không chọn trùng (chống lỗi "không đủ tồn" muộn).
    excludedIds() {
      return this.excludedBatchStockIds || [];
    },
  },
  methods: {
    convertPrice,
    fetchData(productId) {
      this.onLoading = true;

      // bucket='warranty' => hiển thị/gate theo warrantyQuantity (chuyển kho bảo hành); mặc định inStock.
      const quantityField =
        this.bucket === 'warranty' ? 'warrantyQuantity' : 'inStockQuantity';
      const paramQuery = {
        params: new ProductBatchQueryParams({
          productId: productId,
          storeIds: [this.storeId],
          page: this.queryParams.page,
          limit: this.queryParams.limit,
          batchCode: this.queryParams.batchCode,
          bucket: this.bucket,
        }),
      };
      ApiService.query('productSearch/search-by-batch-code', paramQuery)
        .then(({ data }) => {
          this.listItem = data.data.result.map((element) => {
            return {
              id: element.id,
              batchCode: element.batchCode,
              productName: element.productName,
              importDate: element.importDate,
              availableQuantity: element[quantityField]
                ? element[quantityField]
                : 0,
            };
          });
          this.mapPagination(data);
        })
        .catch((error) => {
          this.onLoading = false;
          const { message } = error.response;
          makeToastFaile(message || 'Lỗi');
        })
        .finally(() => {
          this.onLoading = false;
        });
    },

    showModal: function (productId, currentBatchStockId = null) {
      this.currentSelectedId = currentBatchStockId;
      // R4-M2: reset phân trang/tìm kiếm trước khi mở (component DÙNG CHUNG) — tránh hiện
      // trang/batchCode còn sót của SP mở trước đó.
      this.queryParams.page = 1;
      this.queryParams.batchCode = null;
      this.fetchData(productId);
      this.productId = productId;
      this.modalTitle = `<div>
              <span class='d-block' style='font-size: 1.1rem'>Chọn mã lô — <a class='text-primary'>${this.productName}</a></span>
              </div>`;
      this.$refs['list-product-batch-modal'].show();
    },
    formatBatchDate(date) {
      return date ? formatDate(date, 'DD/MM/YYYY') : '—';
    },
    batchAgeText(date) {
      if (!date) return '';
      const diff = Math.floor((Date.now() - new Date(date).getTime()) / 86400000);
      if (diff <= 0) return 'Hôm nay';
      return `${diff} ngày`;
    },
    rowClass(item) {
      return item && item.id === this.currentSelectedId ? 'table-success' : '';
    },
    hideModal: function () {
      this.$refs['list-product-batch-modal'].hide();
    },
    applyProductBatchStockCode(
      productBatchStockId,
      productBatchStockCode,
    ) {
      this.$emit(
        'productBatchStockCode',
        productBatchStockId,
        productBatchStockCode,
        this.parent,
      );
      this.hideModal();
    },
    onFilter() {
      this.queryParams.page = 1;
      this.fetchData(this.productId);
    },
    closeModal() {
      this.resetData();
      this.$refs['list-product-batch-modal'].hide();
    },
    resetData() {
      this.queryParams.batchCode = null;
    },
    handlePageChange(pageNum) {
      this.queryParams.page = pageNum ? parseInt(pageNum) : 1;
      this.fetchData(this.productId);
    },
  },
};
</script>
